export const userStorage = {
  setUser(user) {
    sessionStorage.setItem("user", JSON.stringify(user));
  },

  getUser() {
    const user = sessionStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  clear() {
    sessionStorage.clear();
  }
};